import Assign from './Assign/Assign';
import UpdateCell from './UpdateCell/UpdateCell';
import DeleteColumn from './DeleteColumn/DeleteColumn';
import DeleteRow from './DeleteRow/DeleteRow';
import Duplicate from './Duplicate/Duplicate';
import GetColumn from './GetColumn/GetColumn';
import InsertColumn from './InsertColumn/InsertColumn';
import InsertRow from './InsertRow/InsertRow';
import Join from './Join/Join';
import Merge from './Merge/Merge';
import Length from './Length/Length';
import SortRows from './SortRows/SortRows';
import FilterRows from './FilterRows/FilterRows';
import LimitRows from './LimitRows/LimitRows';
import MergeDuplicateRows from './MergeDuplicateRows/MergeDuplicateRows';
import FillBlankCells from './FillBlankCells/FillBlankCells';
import SplitCoumns from './SplitColumns/SplitColumns';
import ReplaceWithRegex from './ReplaceWithRegex/ReplaceWithRegex';
import AddRowNumbers from './AddRowNumbers/AddRowNumbers';
import CombineTables from './CombineTables/CombineTables';
import MergeTables from './MergeTables/MergeTables';
import RotateTable from './RotateTable/RotateTable';
import TextFormatting from './TextFormatting/TextFormatting';
import FindAndReplace from './FindAndReplace/FindAndReplace';
import MergeColumns from './MergeColumns/MergeColumns';
import FindMaxByGroup from './FindMaxByGroup/FindMaxByGroup';
import FindMinByGroup from './FindMinByGroup/FindMinByGroup';
import MathByGroup from './MathByGroup/MathByGroup';
import FindAndClean from './FindAndClean/FindAndClean';
import ExportToCsv from './ExportToCsv/ExportToCsv';

import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, automId, automVersionId, variableRender, automDetail, visible) {
    switch (action.actionName) {
        case types.ADDROWNUMBERS:
            return <AddRowNumbers action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.ASSIGN:
            return <Assign action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.DUPLICATE:
            return <Duplicate action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.FILLBLANKCELLS:
            return <FillBlankCells action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.FILTERROWS:
            return <FilterRows action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}
                automDetail={automDetail} automId={automId} automVersionId={automVersionId} variableRender={variableRender} visible={visible} />;
        case types.FINDANDCLEAN:
            return <FindAndClean action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.FINDANDREPLACE:
            return <FindAndReplace action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.FINDMAXBYGROUP:
            return <FindMaxByGroup action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.FINDMINBYGROUP:
            return <FindMinByGroup action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.INSERTROW:
            return <InsertRow action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.LIMITROWS:
            return <LimitRows action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.MATHBYGROUP:
            return <MathByGroup action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.MERGECOLUMNS:
            return <MergeColumns action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.MERGEDUPLITEROWS:
            return <MergeDuplicateRows action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.REPLACEWITHREGEX:
            return <ReplaceWithRegex action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.ROTATETABLE:
            return <RotateTable action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.SORTROWS:
            return <SortRows action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.SPLITCOLUMNS:
            return <SplitCoumns action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.TEXTFORMATTING:
            return <TextFormatting action={action} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;
        case types.UPDATECELL:
            return <UpdateCell action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} visible={visible} />;










        case types.DELCOLUMN:
            return <DeleteColumn action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.DELROW:
            return <DeleteRow action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.INSERTCOLUMN:
            return <InsertColumn action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.JOIN:
            return <Join action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.MERGE:
            return <Merge action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.GETCOLUMN:
            return <GetColumn action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.LENGTH:
            return <Length action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.COMBINETABLES:
            return <CombineTables action={action} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.MERGETABLES:
            return <MergeTables action={action} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.EXPORTTOCSV:
            return <ExportToCsv action={action} variables={variables} setOpenVariable={setOpenVariable} automId={automId}/>;
        default:
            break;
    }

}
export default Actions;
